window.addEventListener('load', assignDataSafetyEvents);
window.addEventListener('turbolinks:load', assignDataSafetyEvents);

function assignDataSafetyEvents() {
  const dataSafetyFormElements = document.querySelectorAll('[id^=data_safety]');
  dataSafetyFormElements.forEach(element => {
    element.addEventListener('input', disableAttachmentLinks);
  });
}

function disableAttachmentLinks() {
  const attachmentLinks = document.querySelectorAll('[name^=delete_attachment]')
  attachmentLinks.forEach(link => link.disabled = true)
  document.getElementById('disabled-label').classList.remove('hidden');
}